var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBasket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dustbin_120823 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.489 7.91004C21.489 7.68575 21.6709 7.50378 21.8952 7.50378C22.1194 7.50378 22.3015 7.68657 22.3015 7.91004V23.4948C22.3015 24.1829 22.0187 24.8092 21.5651 25.2637C21.1115 25.7173 20.4843 26 19.7962 26H7.20248C6.51439 26 5.88641 25.7173 5.43359 25.2637C4.97995 24.8101 4.69727 24.1838 4.69727 23.4948V7.91004C4.69727 7.68575 4.87924 7.50378 5.10349 7.50378C5.32778 7.50378 5.50975 7.68657 5.50975 7.91004V23.4948C5.50975 23.9587 5.70105 24.3827 6.00742 24.689C6.31379 24.9954 6.73783 25.1875 7.20163 25.1875H19.7955C20.2592 25.1875 20.6824 24.9953 20.9888 24.689C21.296 24.3818 21.4873 23.9586 21.4873 23.4957V7.91004H21.489Z",
    fill: "#5F6C72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.4697 22.4453C10.4697 22.6696 10.2878 22.8515 10.0635 22.8515C9.8392 22.8515 9.65723 22.6696 9.65723 22.4453V8.01496C9.65723 7.79067 9.8392 7.6087 10.0635 7.6087C10.2878 7.6087 10.4697 7.79067 10.4697 8.01496V22.4453Z",
    fill: "#5F6C72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.9062 22.4453C13.9062 22.6696 13.7243 22.8515 13.5 22.8515C13.2757 22.8515 13.0938 22.6696 13.0938 22.4453V8.01496C13.0938 7.79067 13.2757 7.6087 13.5 7.6087C13.7243 7.6087 13.9062 7.79067 13.9062 8.01496V22.4453Z",
    fill: "#5F6C72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M17.3427 22.4453C17.3427 22.6696 17.1608 22.8515 16.9365 22.8515C16.7122 22.8515 16.5303 22.6696 16.5303 22.4453V8.01496C16.5303 7.79067 16.7122 7.6087 16.9365 7.6087C17.1608 7.6087 17.3427 7.79067 17.3427 8.01496V22.4453Z",
    fill: "#5F6C72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M10.2324 2.50521C10.2324 2.7295 10.0504 2.91147 9.82615 2.91147C9.60189 2.91147 9.41992 2.7295 9.41992 2.50521C9.41992 1.81542 9.70175 1.18914 10.1554 0.7355C10.6091 0.281824 11.2354 0 11.9251 0H15.0736C15.7625 0 16.3888 0.282679 16.8424 0.736319C17.296 1.18996 17.5788 1.81795 17.5788 2.50521C17.5788 2.7295 17.3968 2.91147 17.1725 2.91147C16.9482 2.91147 16.7663 2.7295 16.7663 2.50521C16.7663 2.04142 16.575 1.61738 16.2686 1.31101C15.9622 1.00461 15.5382 0.812484 15.0744 0.812484H11.926C11.4614 0.812484 11.0382 1.00375 10.731 1.31016C10.4237 1.61738 10.2324 2.04056 10.2324 2.50521Z",
    fill: "#5F6C72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M4.05435 3.67316H22.945C23.3436 3.67316 23.7075 3.83649 23.9716 4.10058L23.9733 4.10229C24.2374 4.36634 24.4007 4.73027 24.4007 5.12891V6.1784C24.4007 6.40266 24.2188 6.58463 23.9945 6.58463H23.9835H3.00489C2.7806 6.58463 2.59863 6.40266 2.59863 6.1784V6.16825V5.12891C2.59863 4.73113 2.76197 4.36634 3.02605 4.10229L3.02776 4.10058C3.29181 3.83653 3.65657 3.67316 4.05435 3.67316ZM22.945 4.48568H4.05435C3.87748 4.48568 3.71581 4.55764 3.60071 4.67356L3.599 4.67527C3.48304 4.79034 3.41112 4.95118 3.41112 5.12891V5.77214H23.5874V5.12891C23.5874 4.95203 23.5154 4.79037 23.3995 4.67527L23.3978 4.67356C23.2828 4.55764 23.1219 4.48568 22.945 4.48568Z",
    fill: "#5F6C72"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBasket);
export default __webpack_public_path__ + "static/media/icon-basket.6b6a5980a82fd1275ee9102c50f946b9.svg";
export { ForwardRef as ReactComponent };